// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_uHL","cls2":"EvaluationPage-cls2_8If EvaluationPage-cls1_uHL"};